import mongoose from 'mongoose';
import availabilityCodeCache, {
  IAvailabilityCodeCacheDocument,
} from '../schemas/availability-code-cache';

export default (mongoose.models.AvailabilityCodeCache ||
  mongoose.model<IAvailabilityCodeCacheDocument>(
    'AvailabilityCodeCache',
    availabilityCodeCache,
  )) as mongoose.Model<IAvailabilityCodeCacheDocument>;
